// Module
var code = "<style>:host{height:inherit;width:100%;display:inline-block}</style> <slot></slot>";
// Exports
export default code;